import { Form } from 'antd';
import style from './index.module.scss';
import { Button, ContentLayout, Input, Logo, PageLayout } from 'components';
import { useCallback } from 'react';
import { useAuth } from 'hooks/useAuth';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

type TSignUpData = {
  email: string;
  password: string;
};

export const SignIn = () => {
  const { signIn, isLoading, forgetPassword } = useAuth();
  const [form] = Form.useForm();

  const onFinish = useCallback(
    (data: TSignUpData) => {
      signIn(data.email, data.password);
    },
    [signIn],
  );

  const forgotPassword = useCallback(async () => {
    const email = form.getFieldValue('email');
    if (email) {
      await forgetPassword(email);
    } else {
      form.setFields([
        {
          name: 'email',
          errors: ['Ingrese email para recuperar'],
        },
      ]);
    }
  }, [forgetPassword, form]);

  return (
    <PageLayout className={style.singin}>
      <ContentLayout>
        <Logo className={style.logo} />

        <Form layout={'vertical'} form={form} onFinish={onFinish}>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Email es requerido' },
              { type: 'email', message: 'Email invalido' },
            ]}
          >
            <Input maxLength={40} label="Dirección de Correo" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Contraseña es requerido' }]}
          >
            <Input
              maxLength={16}
              minLength={6}
              label="Contraseña"
              type="password"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>

          <div className={style.footer}>
            <Button
              htmlType="submit"
              className={style.button}
              buttonType="solid"
              shape="round"
              loading={isLoading}
            >
              INGRESAR
            </Button>

            <p className={style.forgotPassword} onClick={forgotPassword}>
              OLVIDÉ MI CONTRASEÑA
            </p>
          </div>
        </Form>
      </ContentLayout>
    </PageLayout>
  );
};
